"use client"
import React from 'react';
import { Button, CardMedia } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const DashboardLogin = () => {
    const navi = useNavigate();

    return (
        <Button
            variant="outlined"
            onClick={() => navi('/signin')}
            sx={{
                marginRight: "20px"
            }}
        >
            Dashboard Login
        </Button>
    )
}

export default DashboardLogin;